import React from 'react';
import styled from 'styled-components';
import Mundo from '@catalogo/ui-americanas-desktop-svg/icon-mundo.svg';
import ArrowDown from '@catalogo/ui-americanas-desktop-svg/arrow-discount.svg';
import { PriceText } from '../styles';

const Stamp = ({ international }) => {
  if (international) {
    return <MundoUI width="85px" height="22px" />;
  }
  return null;
};

export const BestPrice = ({ defaultPriceText, payment, international, isFloating, isNurslingProduct }) => {
  if (!payment) {
    return (
      <>
        <Label>A partir de: </Label>
        <PriceText $isFloating={isFloating}>{defaultPriceText}</PriceText>
      </>
    );
  }

  const { listPriceText, priceText, discount } = payment;
  const { rateText } = discount;

  return (
    <>
      {!isFloating && listPriceText && !isNurslingProduct && (
        <ListPriceWrapper>
          <ListPrice>{listPriceText}</ListPrice>
          <Badge className="badge">
            <Arrow width="10" height="10" fill="#fff" />
            {rateText}
          </Badge>
        </ListPriceWrapper>
      )}
      <PriceWrapper $isFloating={isFloating}>
        <PriceText $isFloating={isFloating} className="priceSales">
          {priceText}
        </PriceText>
        <Stamp international={international} />
      </PriceWrapper>
    </>
  );
};

const MundoUI = styled(Mundo)`
  margin-left: 5px;
`;

const ListPriceWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 5px;
`;

const ListPrice = styled.span`
  text-align: left;
  text-decoration: line-through;
  line-height: normal;
`;

const Badge = styled.div`
  display: flex;
  align-items: center;
  background: ${({ theme }) => theme.card.green};
  color: #fff;
  font-size: 12px;
  line-height: 18px;
  font-weight: 900;
  border-radius: 5px;
  padding: 0px 5px;
`;

const PriceWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  ${({ $isFloating }) => !$isFloating && 'margin-top: 5px;'};
`;

const Arrow = styled(ArrowDown)`
  margin-right: 1px;
`;

const Label = styled.label`
  font-size: 14px;
  line-height: 1.42857;
  ${({ theme }) => theme.grey.dark};
`;
